module.exports = __webpack_public_path__ + "71f98d7858ec80cc7255a1d869590922.jpg";